// The LIST-page skeleton: heading → stat tiles → toolbar → table.
//
// Anatomy ported from libms PageSkeleton (bg-white → bg-base-100, card radii →
// rounded-500, the 8px card step of DEV-GUIDE-002 §12.1) and kept as-is, but the
// bones now come from ../skeleton — there is ONE shimmer implementation in the
// repo, not two. Form pages use <FormSkeleton>
// and detail pages <DetailSkeleton>; this one is for lists only.
import { Skeleton, StatRowSkeleton, TableSkeleton } from '../skeleton';

/** List-page body skeleton mirroring the dominant list anatomy. Purely presentational. */
export function PageSkeleton(props: { id?: string }) {
  return (
    <div class="flex flex-col gap-5" aria-hidden="true" id={props.id ?? 'page-skeleton'}>
      {/* PageHeading: h1 + subtitle, actions on the right */}
      <div class="flex items-start justify-between gap-4">
        <div class="flex flex-col gap-2.5">
          <Skeleton class="h-7 w-56" />
          <Skeleton class="h-3.5 w-80 max-w-[60vw]" />
        </div>
        <div class="flex items-center gap-2">
          <Skeleton shape="pill" class="h-8 w-24" />
          <Skeleton shape="pill" class="h-8 w-32" />
        </div>
      </div>

      {/* StatCard row */}
      <StatRowSkeleton count={4} />

      {/* Toolbar + DataTable inside the list card */}
      <div class="overflow-hidden rounded-500 border border-base-300 bg-base-100">
        <div class="flex items-center gap-3 border-b border-base-300 p-3.5">
          <Skeleton class="h-8 w-64" />
          <Skeleton class="h-8 w-32" />
          <div class="ml-auto flex items-center gap-2">
            <Skeleton class="h-8 w-8" />
            <Skeleton shape="pill" class="h-8 w-24" />
          </div>
        </div>
        <TableSkeleton rows={8} cols={5} />
      </div>
    </div>
  );
}
